/**
 * App router (M2.1). Three interface routes per game (FR-9.1): each is addressable
 * by a distinct URL. Content separation between them is enforced server-side
 * (role-filtered payloads); these routes just select which surface to render.
 *
 * A layout wrapper renders the site-wide {@link Footer} below every route (#126,
 * FR-13.1) — the single place that reaches every surface — plus the static legal
 * routes (`/terms`, `/privacy`, `/refunds`), which are unauthenticated and
 * prerenderable.
 */

import { Route, Routes } from 'react-router-dom';
import { Footer } from './ui/Footer';
import { Landing } from './pages/Landing';
import { DemoPage } from './pages/Demo';
import { HostPage } from './pages/HostPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { PlayerPage } from './pages/PlayerPage';
import { PresentationPage } from './pages/PresentationPage';
import { ProfilePage } from './pages/ProfilePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { RefundsPage } from './pages/RefundsPage';
import { TermsPage } from './pages/TermsPage';
import { FaqPage } from './pages/FaqPage';
import { TriviaIndex } from './pages/TriviaIndex';
import { TriviaSet } from './pages/TriviaSet';
import { SeoLanding } from './pages/SeoLanding';
import { SEO_LANDING_PATHS } from './seo/seo-landings';

export function App(): React.JSX.Element {
  return (
    <div className="app-root">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/host" element={<HostPage />} />
        <Route path="/player" element={<PlayerPage />} />
        <Route path="/presentation" element={<PresentationPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/trivia" element={<TriviaIndex />} />
        <Route path="/trivia/:slug" element={<TriviaSet />} />
        {/* #353 (FR-15.7): product-intent Jeopardy-style landing pages, one shared template. */}
        {SEO_LANDING_PATHS.map((path) => (
          <Route key={path} path={path} element={<SeoLanding path={path} />} />
        ))}
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/refunds" element={<RefundsPage />} />
      </Routes>
      <Footer />
    </div>
  );
}
